/* eslint-disable no-useless-computed-key */
import { createContext, useContext, useReducer } from 'react'
import { sidebarConst } from '../utils/action.constant'

const SidebarContext = createContext()
export const useSidebarContext = () => useContext(SidebarContext)

const initialState = {
  sidebarCollapsed: {
    isCollapsed:false
  },
}

const SidebarReducer = (state, action) => {
  switch (action.type) {
    case sidebarConst.SET_COLLAPSED:
      return {
        ...state,
        sidebarCollapsed:{
        ...state.sidebarCollapsed,
          ['isCollapsed']: true
        }
      };
      case sidebarConst.SET_EXPANDED:
        return {
          ...state,
          sidebarCollapsed:{
          ...state.sidebarCollapsed,
            ['isCollapsed']: false
          }
        };
    default:
      return state
  }
}

export const SidebarContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(SidebarReducer, initialState)

  return (
    <SidebarContext.Provider value={{ state, dispatch }}>
      {children}
    </SidebarContext.Provider>
  )
}
